import React from "react";

function TrafficHomeOne({ className }) {
  return (
    <section className={`appie-service-area pt-140 pb-180 ${className || ""}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="appie-traffic-title">
              <h3 className="title">Snooker Rules and Regulations</h3>
              <p>
                • The competition would be player-wise & not club-wise where
                maximum 3 players & minimum 1 player can play
              </p>
              <p>
                • Direct Knockout Matches (a set of 32 will be played and
                accordingly depending upon the number of players, few players
                will be given a bye and would be qualified for the next round.
              </p>
              <p>
                • There will be no more than 5 consecutive foul and a miss calls
                at any time
              </p>
              <p>
                • As a consequence to above, following options are available
                with the non-striker –
              </p>
              <p>1. Play himself from where the balls have come to rest</p>
              <p>
                2. Ask the opponent to play from where the balls have come to
                rest
              </p>
              <p>
                3. Place the cue ball anywhere on the table, but this option
                cannot be taken if play has reached the “Snookers Required”
                stage
              </p>
              <p>
                4. A player cannot snooker behind a nominated colour at any
                time.
              </p>
              <p>5. All other standard Snooker Rules would be applicable.</p>
              <p>6. The decision of the referee would be final </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficHomeOne;
